import { render, staticRenderFns } from "./buyTypeList.vue?vue&type=template&id=07722633&"
import script from "./buyTypeList.vue?vue&type=script&lang=js&"
export * from "./buyTypeList.vue?vue&type=script&lang=js&"
import style0 from "./buyTypeList.vue?vue&type=style&index=0&id=07722633&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports